export default __webpack_public_path__ + "static/media/logohb.02126a41.svg";